import { render, staticRenderFns } from "./CourseComponent.vue?vue&type=template&id=ee2217b0&scoped=true&"
import script from "./courseComponent.js?vue&type=script&lang=js&"
export * from "./courseComponent.js?vue&type=script&lang=js&"
import style0 from "./CourseComponent.vue?vue&type=style&index=0&id=ee2217b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2217b0",
  null
  
)

export default component.exports